import React from "react";
import { Phone } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const MobileStickyCTA = () => {
  const { t } = useLanguage();
  return (
    <a
      href="tel:01708251779"
      data-testid="sticky-call-cta"
      className="md:hidden fixed bottom-4 left-4 right-4 z-40 inline-flex items-center justify-center gap-3 bg-[#06B6D4] hover:bg-[#0891B2] text-white font-semibold px-5 py-4 shadow-2xl"
    >
      <Phone size={18} />
      {t.stickyCta} · 0170 8251779
    </a>
  );
};
